import { PROSPECT_CLIENT_ID_KEY } from "client/constants";

import { generateRandomId } from "./generate-random-id";

const sessionId = generateRandomId();

export const getSessionId = (): string => sessionId;

// will be used to handle clientId across sessions for LD, Amplitude, Sentry
export const getClientId = (): string => {
  let clientId = localStorage?.getItem(PROSPECT_CLIENT_ID_KEY);
  if (!clientId) {
    clientId = generateRandomId();
    localStorage?.setItem(PROSPECT_CLIENT_ID_KEY, clientId);
  }
  return clientId;
};
